/**
 * Configuration du programme d'affiliation.
 * Les candidatures sont gérées hors app via un formulaire Fillout.
 */
export const FILLOUT_APPLICATION_URL = "https://1hxcgrh186.zite.so";
